import { graphql } from '@apollo/client/react/hoc'

import getCountry from '../../helpers/get-country'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ staticContext }) => {
  const country = getCountry(staticContext)

  return {
    variables: {
      centresQuery: `fields.country=${country}&fields.status[nin]=Closed`,
      natHomeQuery: `fields.country=${country}`,
    },
    errorPolicy: 'ignore',
  }
}

export const mapDataToProps = ({
  data: { error, loading, centres, redirect, nationalHomepages },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!centres[0]) {
    return {
      error: new NotFoundError(error),
    }
  }

  return {
    homePageInfo: nationalHomepages[0],
    centres: centres
      .filter(Boolean)
      .sort((a, b) => a.title.localeCompare(b.title)),
    // Possible to receive empty/undefined (possibly due to status filter?)- so need to: .filter(Boolean) to remove
  }
}

const withCentreSelector = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withCentreSelector
